module.exports = __webpack_public_path__ + "img/40_38_031_840.583549f8.jpg";